import { useState, useEffect } from 'react';
import DestinationBar from '../components/DestinationBar';
import FilterTabs from '../components/FilterTabs';
import { useDestinations } from '../data/dataComponent';

const LeftPanel = ({
  selectedDestinationId,
  setSelectedDestinationId,
  filteredDestinations,
  setFilteredDestinations,
  isCollapsed,
  setIsCollapsed,
}) => {
  const [selectedType, setSelectedType] = useState('All');
  const [searchQuery, setSearchQuery] = useState('');
  const { destinations, loading } = useDestinations();

  useEffect(() => {
    if (!loading && Array.isArray(destinations) && destinations.length > 0) {
      let filtered = destinations;
      if (selectedType !== 'All') {
        filtered = destinations.filter(dest => dest.type === selectedType);
      }
      filtered = filtered.filter(dest =>
        dest.name.toLowerCase().includes(searchQuery.toLowerCase())
      );
      setFilteredDestinations(filtered);
      if (filtered.length > 0) {
        setSelectedDestinationId(filtered[0].id);
      }
    }
  }, [
    destinations,
    loading,
    selectedType,
    searchQuery,
    setFilteredDestinations,
    setSelectedDestinationId,
  ]);

  return (
    <div
      className={`
        bg-white rounded-lg shadow-md p-2
        ${isCollapsed ? 'w-10' : 'w-full md:w-64'}
        min-w-[40px] max-w-[260px]
        mr-2 mb-2 md:mb-0
        relative
      `}
    >
      {/* Only show the button when collapsed */}
      {isCollapsed && (
        <button
          className="mb-2 p-1 rounded-full hover:bg-gray-100"
          onClick={() => setIsCollapsed(!isCollapsed)}
          aria-label="Expand panel"
        >
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
          </svg>
        </button>
      )}
      {!isCollapsed && (
        <>
          <div className="relative flex items-center mb-2">
            <input
              type="text"
              placeholder="Search..."
              className="flex-1 min-w-0 px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500 pr-8"
              value={searchQuery}
              onChange={e => setSearchQuery(e.target.value)}
            />
            {searchQuery ? (
              <button
                className="absolute right-2 top-1/2 -translate-y-1/2 p-1 rounded-full bg-gray-200 hover:bg-gray-300 text-gray-600 hover:text-gray-800"
                onClick={() => setSearchQuery('')}
                aria-label="Clear search"
                title="Clear search"
                tabIndex={0}
                type="button"
              >
                {/* Clear (X in a circle) icon */}
                <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 20 20">
                  <circle cx="10" cy="10" r="9" stroke="currentColor" fill="white"/>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M7 7l6 6m0-6l-6 6" />
                </svg>
              </button>
            ) : (
              <button
                className="ml-2 p-1 rounded-full hover:bg-gray-100 flex-shrink-0 min-w-[36px]"
                onClick={() => setIsCollapsed(true)}
                aria-label="Collapse panel"
                type="button"
              >
                {/* Collapse icon */}
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            )}
          </div>
          <FilterTabs selectedType={selectedType} onSelectType={setSelectedType} />
          <DestinationBar
            destinations={filteredDestinations}
            selectedId={selectedDestinationId}
            onSelectDestination={setSelectedDestinationId}
          />
        </>
      )}
    </div>
  );
};

export default LeftPanel;